import React from 'react'
import './ProfileAuthorNavCard.css'
import { AppBar, Tab, Tabs } from '@material-ui/core'
import Created from './Pages/Created'
import Collections from './Pages/Collections'
import OnSale from './Pages/OnSale'
import UserActivity from './Pages/UserActivity'
import Followers from './Pages/Followers'
import Settings from './Settings'

function ProfileAuthorNavCard() {
    const [selectedTab, setSelectedTab] = React.useState(0);
  
    const handleChange = (event, newValue) => {
        setSelectedTab(newValue);
    };
    return (
        <div className="profileRight">
            <div className="authorProfileNav">
                {/* <AppBar position="static"> */}
                <Tabs value={selectedTab} onChange={handleChange}>
                    <Tab label="On Sale" ></Tab>
                    <Tab label="Created" ></Tab>
                    <Tab label="Collections" ></Tab>
                    <Tab label="Activity" ></Tab>
                    {/* <Tab label="Settings" ></Tab> */}
                </Tabs>
                {/* </AppBar> */}
                {selectedTab === 0 && <OnSale />}
                {selectedTab === 1 && <Created />}
                {selectedTab === 2 && <Collections />}
                {selectedTab === 3 && <UserActivity />}
                {/* {selectedTab === 3 && <Settings />} */}
            </div>
        </div>
    )
}

export default ProfileAuthorNavCard
